<template>
    <div class="site">
        <navbar></navbar>
        <main class="content">
            <div class="container-fluid">
                <div class="col-lg-8 col-lg-offset-2 col-md-12 col-sm-12 col-xs-12">
                    <div v-if="isLoading" class="loader-wrapper">
                        <div class="loader" />
                    </div>
                    <router-view v-else />
                </div>
            </div>
        </main>
        <bottom></bottom>
    </div>
</template>

<script>
import Navbar from "@/components/Navbar"
import Footer from "@/components/Footer"
import { mapGetters, mapActions } from "vuex"

export default {
    name: "App",
    components: {
        navbar: Navbar,
        bottom: Footer
    },
    computed: {
        ...mapGetters({
            isLoading: "getIsLoading"
        })
    },
    methods: {
        ...mapActions({
            initalize: "initalize"
        })
    },
    mounted() {
        this.initalize()
    }
}
</script>

<style>
.content {
    font-family: "Avenir", Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    color: #2c3e50;
    flex: 1;
    padding-top: 61px;
}

.site {
    display: flex;
    min-height: 100vh;
    flex-direction: column;
}

.loader-wrapper {
    position: fixed;
    top: 50%;
    left: 50%;
}

.loader {
    display: inline-block;
    width: 50px;
    height: 50px;
    border: 3px solid rgba(255, 255, 255, 0.3);
    border-radius: 50%;
    border-top-color: green;
    animation: spin 1s ease-in-out infinite;
    -webkit-animation: spin 1s ease-in-out infinite;
}

@keyframes spin {
    to {
        -webkit-transform: rotate(360deg);
    }
}

@-webkit-keyframes spin {
    to {
        -webkit-transform: rotate(360deg);
    }
}

a {
    color: #111111;
    text-decoration: none;
}

a:hover {
    text-decoration: none;
}

.icon,
.icon-label {
    vertical-align: middle;
}

.icon {
    margin-right: 5px;
}

.icon-label {
    cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/App.vue